import React from 'react';
import { styled } from 'baseui';
import { getWordCount } from '../utils/utils';
type PropsT = {
  text: string;
};
const RTEMetaContainer = styled('section', ({
  $theme
}) => ({
  backgroundColor: $theme.colors.backgroundInversePrimary,
  color: $theme.colors.contentInversePrimary,
  padding: $theme.sizing.scale300,
  fontFamily: $theme.typography.font200.fontFamily,
  fontSize: $theme.typography.font200.fontSize,
  display: 'flex',
  gap: $theme.sizing.scale300
}));
const RichTextEditorMeta = ({
  text
}: PropsT) => {
  return <RTEMetaContainer>
      <span>
        Words: <strong>{getWordCount(text)}</strong>
      </span>
      <span>
        Characters: <strong>{(text ?? '').trim().length}</strong>
      </span>
    </RTEMetaContainer>;
};
export default RichTextEditorMeta;